/**
 * Optimised image:
 *   - <picture> with WebP source + JPEG fallback
 *   - Native lazy-loading + async decoding by default
 *   - Override with eager + fetchPriority="high" for the LCP / above-the-fold hero
 *
 * Pass either:
 *   <Img src="/assets/foo.jpg" alt="…" />              // assumes /assets/foo.webp also exists
 *   <Img src="/assets/foo.jpg" webp="/assets/foo.webp" alt="…" />
 *
 * Width/height props help prevent Cumulative Layout Shift.
 */
export default function Img({
  src,
  webp,
  alt = '',
  width,
  height,
  className = '',
  imgClassName = '',
  priority = false,
  sizes,
  ...rest
}) {
  const webpSrc = webp || (src.endsWith('.jpg') ? src.replace(/\.jpg$/, '.webp') : null);

  return (
    <picture className={className}>
      {webpSrc && <source srcSet={webpSrc} type="image/webp" sizes={sizes} />}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={priority ? 'eager' : 'lazy'}
        decoding={priority ? 'sync' : 'async'}
        fetchpriority={priority ? 'high' : 'auto'}
        sizes={sizes}
        className={imgClassName || 'w-full h-full object-cover'}
        {...rest}
      />
    </picture>
  );
}
